import {
  Box,
  Button,
  Paragraph,
  Table,
  TableTbody,
  TableTh,
  TableThead,
  TableTr,
  VisuallyHidden,
} from '@customerio/pluma-components/react';
import { ObjectAttributeRow, type ObjectAttributesEditorState } from '@/features/objects';

type AttributesStepProps = {
  editor: ObjectAttributesEditorState;
  isSaving: boolean;
};

/**
 * The optional attributes every new relationship will carry. Nothing here
 * blocks the submit: a row with no name at all is dropped from the payload,
 * while one whose name the editor rejects shows its error and is still sent,
 * for the backend to accept or refuse.
 */
export function AttributesStep({ editor, isSaving }: AttributesStepProps) {
  return (
    <Box data-test-add-relationships-modal-attributes>
      <Paragraph my="200">
        Adding relationship attributes is optional and can be added later via the relationships table.
      </Paragraph>
      <Table caption="Add relationship attributes" mb="100">
        <TableThead>
          <TableTr>
            <TableTh p="0" style={{ border: 'none', width: '256px' }}>
              <VisuallyHidden>Attribute name</VisuallyHidden>
            </TableTh>
            <TableTh p="0" style={{ border: 'none' }}>
              <VisuallyHidden>Attribute value</VisuallyHidden>
            </TableTh>
          </TableTr>
        </TableThead>
        <TableTbody>
          {editor.rows.map((row) => (
            <ObjectAttributeRow
              key={row.id}
              row={row}
              errors={editor.errorsFor(row)}
              isNew={editor.isNew}
              isSaving={isSaving}
              showErrors={editor.isDirty}
              isMultiIdentifier={false}
              hasReservedNames={false}
              onKeyChange={editor.setKey}
              onValueChange={editor.setValue}
              onRemove={editor.remove}
            />
          ))}
        </TableTbody>
      </Table>
      <Box>
        <Button variant="secondary" icon="add" isDisabled={isSaving} onClick={() => editor.create()}>
          Create new attribute
        </Button>
      </Box>
    </Box>
  );
}
